import { i18n } from '../plugins/i18n'

export const gmbLocationOpenInfoStatus = {
  open: i18n.t('pages.CompaniesLocationStoreOpenInfoEdit.status.open'),
  closed_temporarily: i18n.t('pages.CompaniesLocationStoreOpenInfoEdit.status.closedTemporarily'),
  closed_permanently: i18n.t('pages.CompaniesLocationStoreOpenInfoEdit.status.closedPermanently')
}
